import { useEffect } from 'react';

import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';

import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';

import { DriverProfileForm } from '../DriverProfileForm/DriverProfileForm';
import { RestoreDriverProfileModal } from '../DriverProfileForm/modals/RestoreDriverProfileModal';
import { columns, columnsWithDeletedAt } from './columns';
import { DriverProfileEmptyState } from './DriverProfileEmptyState';
import DriverTagModal from './tags/DriverTagModal';
import { useCurrentOrganizationDriverProfiles } from './useCurrentOrganizationDriverProfiles';

export function DriverProfileRoute() {
  const { drivers, isLoading, refetch } =
    useCurrentOrganizationDriverProfiles();

  const driverProfileSearchTerm = useAppSelector(
    (state) => state.team.driverProfileSearchTerm
  );
  const includeDeleted = useAppSelector(
    (state) => state.team.showDeletedDrivers
  );

  useEffect(() => {
    refetch();
  }, [driverProfileSearchTerm, includeDeleted, refetch]);

  return (
    <>
      <div>
        {isLoading ? (
          <div className="my-72 flex justify-center">
            <LoadingIndicator />
          </div>
        ) : (
          <DataGrid
            tableId="driver-profile"
            dataTestId="driver-profile-data-grid"
            columns={includeDeleted ? columnsWithDeletedAt : columns}
            data={drivers}
            totalCount={drivers.length}
            emptyState={<DriverProfileEmptyState />}
            getRowId={(row) => row.id}
          />
        )}
      </div>
      <DriverProfileForm />
      <RestoreDriverProfileModal />
      <DriverTagModal />
    </>
  );
}
